export default __webpack_public_path__ + "static/media/Hargrove Decatur Cube 2.f9c49dbf.jpg";